import { useEffect } from "react";
import { environment } from "../../../../constant/environment";
import { ENVIRONMENT_TYPE } from "../../../../constant/common";

export const useProductionSecurity = () => {
  useEffect(() => {
    if (environment === ENVIRONMENT_TYPE.PRODUCTION) {
      // Disable right click context menu and ctrl+shift+i for Production(Inspect Menu)
      const handleContextMenu = (e: any) => e.preventDefault();

      const handleKeyDown = (e: KeyboardEvent) => {
        const keyIsI = e.code === "KeyI";
        const keyIsC = e.code === "KeyC";
        const metaLeft = e.code === "MetaLeft";
        const metaRight = e.code === "MetaRight";
        const shiftLeft = e.code === "ShiftLeft";
        const shiftRight = e.code === "ShiftRight";
        const isCtrlShiftI = e.ctrlKey && e.shiftKey && keyIsI;
        const isCtrlShiftC = e.ctrlKey && e.shiftKey && keyIsC;
        const isCMDShiftC = e.metaKey && e.shiftKey && keyIsC;
        const isCMDShiftI = e.metaKey && e.shiftKey && keyIsI;
        const isCmdAltI = e.metaKey && e.altKey && keyIsI;
        const isCmdAltC = e.metaKey && e.altKey && keyIsC;
        const isCtrlAltI = e.metaKey && metaLeft && keyIsC;
        const isCtrlAltC = e.metaKey && metaRight && keyIsI;
        const isMetaKeyLeft = e.metaKey && shiftLeft && keyIsI;
        const isMetaKeyRight = e.metaKey && shiftRight && keyIsC;

        if (
          isCtrlShiftI ||
          isCtrlShiftC ||
          isCmdAltI ||
          isCmdAltC ||
          isCMDShiftC ||
          isCMDShiftI ||
          isCtrlAltI ||
          isCtrlAltC ||
          isMetaKeyLeft ||
          isMetaKeyRight
        ) {
          e.preventDefault();
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      document.addEventListener("contextmenu", handleContextMenu);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("contextmenu", handleContextMenu);
      };
    }
  }, []);
};
